export default function() {
  return [
    {
      component: 'Section',
      props: {
        class: 'post__map-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            data: {
              image: this.customFields.image,
            },
            props: {
              class: 'post__image',
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.content,
            },
            props: {
              class: 'post__centered-text',
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        class: 'post__custom-section',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__content',
            },
            data: {
              content: this.customFields.mainContent,
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            props: {
              class: '',
            },
            data: {
              image: this.customFields.wide.image,
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textCenter,
            },
            props: {
              class: 'post__centered-text',
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textColumn,
            },
            props: {
              class: 'post__content',
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            props: {
              class: '',
            },
            data: {
              image: this.customFields.wide2.image,
            },
          },
        ],
      },
    },

    // Vimeo section
    {
      component: 'Section',
      props: {
        class: '',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Media',
            props: {},
            data: this.customFields.media,
          },
          {
            component: 'Text',
            data: {
              content: this.customFields.media.description,
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textColumn2,
            },
            props: {
              class: 'post__content',
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            props: {
              class: '',
            },
            data: {
              image: this.customFields.wide3.image,
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textColumn3,
            },
            props: {
              class: 'post__content',
            },
          },
        ],
      },
    },

    // Small image
    {
      component: 'Section',
      props: {
        class: 'post__small-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            data: {
              image: this.customFields.mediumImage.image,
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        class: 'post__location',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            props: {
              class: 'post__content post__content-location',
            },
            data: {
              content: this.customFields.communication,
            },
          },

          {
            component: 'Flex',
            props: {
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              gap: '3rem 0rem',
              class: 'post__features',
            },
            blocks: {
              default: this.customFields.features.map((item, index) => {
                return {
                  component: 'Flex',
                  props: {
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '0rem',
                    class: 'post__features-areas',
                  },
                  blocks: {
                    default: [
                      {
                        component: 'Image',
                        data: {
                          image: item.icon,
                        },
                      },
                      {
                        component: 'Text',
                        data: {
                          content: item.title,
                        },

                        props: {
                          class: 'post__features-title',
                        },
                      },
                      {
                        component: 'Text',
                        data: {
                          content: item.subtitle,
                        },

                        props: {
                          class: 'post__features-subtitle',
                        },
                      },
                    ],
                  },
                }
              }),
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textColumn4,
            },
            props: {
              class: 'post__content',
            },
          },
        ],
      },
    },

    // Full width image
    {
      component: 'Section',
      props: {
        class: 'post__wide-image',
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Image',
            data: {
              image: this.customFields.wide4.image,
            },
          },
          {
            component: 'Text',
            data: {
              content: this.customFields.wide4.content,
            },
            props: {
              class: 'post__additional-info-text',
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      props: {
        width: 'small',
      },
      blocks: {
        default: [
          {
            component: 'Text',
            data: {
              content: this.customFields.textColumn5,
            },
            props: {
              class: 'post__content',
            },
          },
        ],
      },
    },
  ]
}
